module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_vm._v("Why I Wanted a JEEP")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My first exposure to the Jeep was back in 1970. I was 3 years old living in the Laurentians of Quebec, Canada, when a strange little vehicle I had never really paid attention to caught my eye. My father’s employer had purchased a Willys CJ3B back in the 1950s to be used as a runabout between his various farm properties and to patrol the fence lines which spanned over 120 miles of both flat and mountainous terrain. On this occasion, though, I would get to ride along with my father on his rounds in the Jeep and I can still remember bouncing along on the back seat holding on for, what I thought at the time, was my life, while my father regaled me of stories of his time with Jeeps during two different wars. Of the stories I remember very little, but I remember oh so much of that Jeep. It was the first time I really felt any regard for a vehicle. We also had a 110″ wheelbase Land Rover on the farm which was my father’s personal vehicle for transporting the horse trailer to shows and events, but it did not leave nearly the impact on me the Jeep had. Unfortunately in the late 1970s, after many years of faithful service, the old Jeep was destroyed in a barn fire. My family had left the farm by this time and I only learned of its fate years later.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm06.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The remains of the Willys CJ3B. A sad end to a hard-working vehicle.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother also fed my love of all things Jeep in a completely different way. Returning from a trip to England around 1975 my mother brought me a gift of the Tamiya Models SAS Jeep in 1/35 scale. My father built it for me with a basic paint job and I loved it. I would play with it for hours pretending I was part of the Rat Patrol which was still being shown in repeats on TV. This show definitely put stars in my eyes and compounded my regard for the Jeep. Many years later, after the passing of my mother, I found a small picture of her while serving in the Royal Air Force sitting in a Jeep somewhere near Berlin in 1947. This was just further incentive to admire the Jeep, my mother had also driven one. Mind you, my mother also rode a motorcycle in Berlin but I still have yet to get involved in that rabbit hole.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm07.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("My mother in Berlin in 1946 in a Jeep my father had issued to him as part of the Berlin Occupation Force. Notice the last letter on the hood registration is an ‘S’ which designates that this Jeep has a radio suppression system installed.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm08.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("1/35 Tamiya SAS Jeep, My first ever plastic model kit.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another turning point in my life was well before my mother’s passing. In late 1986 I joined my local army reserve unit; the Queen’s York Rangers A Squadron, a light armored reconnaissance unit which to my immense joy used the M38A1 Jeep as their primary vehicle. I would be trained to service, drive and eventually command this vehicle. Up to this point I had never learned to drive a manual transmission and that, of course, was the first thing I learned on the Jeep. How robust those Jeeps were as, year after year, young men and women learned the essentials of driving a 3-speed stick shift. I must admit I did my share of grinding gears and popping the clutch. Later, as my training progressed, I learned the basics of maintaining the Jeep in the field along with all its equipment such as the 7.62 GPMG which was essentially a re-bored M1919A4 Browning Machine Gun of WWII vintage. Mind you, firing the 7.62 GPMG (General Purpose Machine Gun) from the passenger’s side mounting really shook the bolts loose on the old Jeeps. In addition to the GPMG, the standard Canadian vehicle-mounted radio of the era was the RT-524 or 46 set as it was more commonly known "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("among the troops. This radio tested the vehicle’s 24-volt batteries to the max as it drew a lot of power while in use. Many times vehicles needed to be slaved (jump started) as the radio operator had forgotten to shut down his power after bunking down, or had not started the vehicle overnight during a radio watch to keep the batteries charged – yeah, I’m guilty. It was amazing how such a simple vehicle could be kept in working order and combat-ready so long as you paid attention to its basic needs. During my time with the Queen’s Rangers we also used the more modern brother of the M38A1, the American Motors Corporation (AMC) Jeep CJ-7. While a nicer ride than the old M38A1, the CJ-7 just didn’t have the same feel or mystique as the M38A1 and I much preferred to drive it on exercise. The CJ-7 was great for sojourns into the city when the need arose, but the M38A1 was definitely my choice for field work. The M38A1 I generally worked with had a manufacturing date of 1967, my birth year. This Jeep was the same age as myself and was still serving her country faithfully when most other vehicles had been retired to museums and the scrap yard. Who knows where the Jeep I worked with is today, in private hands, a museum maybe, or perhaps it ended up in the scrap yards. Either way, I will always remember my time with it and my mates with fondness.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm09.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A restored Kaiser Willys M38A1 Reconnaissance Jeep in full combat gear. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo courtesy of Allan Dornan")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After I left the army I never really thought much about Jeeps as my life was always busy with work and the day-to-day happenings. I was always an avid plastic modeler though and had built many Jeep models over the ensuing years but had never thought of actually moving up to a 1:1 scale Jeep. I figured I would never have the funds to buy a Jeep, let alone restore one myself. As it happened, I essentially fell into my first Jeep through a co-worker at a new company I began working for. He mentioned in "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("passing that he had an old army Jeep he was trying to sell as his parents were moving into a retirement home and it was just sitting in their barn.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm10.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("New Brunswick 8th Hussars Willys Kaiser Jeep 1964. Photo courtesy of 8th New Brunswick Hussars Museum.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think he noticed the slight twitch and drool that started happening to me and he asked if I may be interested. It was a bargain price and I agreed without even seeing it. I figured: ‘how bad could it be?’ Little did I realize that his army Jeep was actually a 1946 CJ2A that had once been owned by the Canadian Army and demobbed in the late 1950s. It had some markings left on it, along with an old Royal Canadian Electrical Mechanical Engineers (RCEME) engine rebuild tag still mounted on the engine. This at least verified its military origins; as Canada never truly purchased early CJs for military use it was a bit of a mystery vehicle. Once I had finally decided that I wanted the CJ2A I handed over the $350 to my new friend, borrowed a flatbed truck from work and got it home to my tiny garage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have to inject this here. At this stage of the game I knew nothing of WWII Jeeps. I didn’t even realize the body styles of the MB and CJ were different. I knew it was not an M38A1, but that’s about it. I didn’t even know that Ford had produced Jeeps. Looking back I was so unprepared for this hobby it’s not even funny. So: Lesson 1… do some research.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anyway, once I got the Jeep home I realized the full extent of the work in front of me. The Jeep’s metal body and frame were pretty much beyond recovery, rust and time had done its work. There were, however, many salvageable parts on the old Jeep "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("which were left over from the WWII assembly line – though I didn’t yet know that. These parts consisted of everything from the bolts holding it together to many engine and drive-train components. I had very little technical knowledge of the differences between a WWII Jeep and the civilian Jeep; this took time to figure, thanks to some soon-to-be good friends pointing them out as well as basic internet searches. But of course by the time I did understand, I had either thrown out or sold the parts that I should have been keeping. And this brings me to Lesson 2… do not throw out or sell anything! Keep it, store it, hide it, just don’t get rid of it until you know for sure you don’t need it – but even then rethink your decision.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm11.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("My first Jeep, a 1946 CJ looking thoroughly abused and forlorn.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm12.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Oil leaks, broken springs, broken and bent cross-members and cobwebs didn’t deter me.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm13.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("1946 engine compartment. Surprisingly the carburetor and fuel pump are of WWII vintage.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm14.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("RCEME engine rebuild tag showing the 1956 rebuild date and specifications.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm15.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Unloading at home. So exciting, for me anyway. Couldn’t wait to tear into the Jeep.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm16.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("My new pride and joy at home. Note the small garage.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm17.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The 1946 engine in all its dirty glory.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm18.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Preparing to remove parts from the engine. I covered all the possible places dirt and debris can fall into and foul up or damage the salvageable parts.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You will definitely need a spot where you can work on your Jeep and then hide it away from both your neighbors and your spouse. Having a small cluttered garage also allows you to hide all the new tools that you will require though, and this will save many arguments down the road as your caring and wonderfully understanding wife or significant other will never get to see them. The small space I had at the time worked out well for me though; there was so much grease, oil and scrap metal lying around, it was months before wifey realized the smallest extent of my purchases, I may just have shot myself in the foot in writing that sentence. My garage, or shop as I called it when I first began to get into the hobby, was a 10′ × 18′ box that barely had room to get both the Jeep and myself in at the same time. I understand now, though, that many people are in the same situation, especially in Europe where the cars are generally smaller than their North American counterparts. In North America garages are only a secondary thought when a house is built in a subdivision and most of them are so small even a compact car has a difficult time getting in. I made do with what I had, though, as many hobbyists over the years have done as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The process of tearing apart the Jeep and cleaning up all the parts was time consuming and smelly. I had many complaints of a chemical smell leaking into the house. I was using copious amounts of degreaser and brake cleaner trying to clean the various engine and drive train parts of sixty years of grease and oil. I went through bags and bags of rags and old towels in the cleanup. All these went into a sealed steel drum that I bought from a scrap yard, which I then stored in the backyard away from the house. I didn’t need a combustion fire starting in the garage.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm19.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("My garage, not a lot of room there.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm20.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("In this photo you can see the CJs T-90 transmission hump. This is quite different to what is found on the MB using the T-84 transmission. The steering wheel is of WWII vintage being a Sheller production type. This same wheel is now on my 1942 MB.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm21.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("You can see the difference in the transmission humps with this comparison photo of the T-84 hump on a Willys MB.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm22.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Years of oil, grease and dirt to be removed from the flywheel and clutch.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm23.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lots of oil buildup on the front axle and differential from a leaking engine.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My first job was to tear the old Jeep down into manageable parts. The first to go was the metalwork. The body tub was so rusty you could watch it deteriorating if you stood still for a few minutes. The CJ2A had been used as a plow Jeep by my friend’s family and it was always left outside summer or winter. The combination of the elements, the long wet grass growing around it and the plow straining the frame slowly but surely broke it down. At some point a metal cab was purchased for the CJ "), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _vm._v("to help with the winter cold of Canada while plowing and I was hoping that maybe I could save it for some future use. But unfortunately it would require much new metalwork to bring it back to a usable condition. It was not a high priority either as I was planning on building a wartime Jeep which did not require the cab. I have to say, to this point I was simply more intent on getting the old CJ2A stripped and finding out what parts I could salvage and what was junk. I had no plan and no knowledge, which ended up being my two worst enemies. I simply started stripping, cutting and generally hacking apart the old Jeep. I ended up losing parts that I could have salvaged and sold to other hobbyists rebuilding CJs but this didn’t even enter my mind. I guess you do learn through your mistakes. My lack of knowledge on the basic strategy of salvaging cost me down the road. Heck, I didn’t even realize that the lug nuts holding the wheels on were left- and right-hand threaded. This caused me much chagrin trying to get the passenger side wheels off. I unfortunately damaged the rims trying to do so. I later learned that left- and right-hand wheel nuts were common until the late 1940s and into the 1950s. Again I should have done some more research or got a bit more patience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not long after I got the CJ home and stripped down I was offered one of two Jeeps by a recent acquaintance from an online forum I had found. He lived relatively close to me and was an active member in the local military restoration and historical scene and a member of the Ontario Military Vehicle Association. Both of these Jeeps were of WWII vintage, one a 1944 Ford and one a 1945 Willys. Both were in very rough shape and had no ownerships, but the owner told me they had many useful parts and would help me out in the long run no matter which one I chose. When I arrived to pick up my newest Jeep I was surprised because originally I thought I was getting my choice of only one of the Jeeps, but the owner had decided I could have both for the low sum of $400, which was a steal in my eyes. He decided that, between my enthusiasm and the need to get the Jeeps out of his storage yard, they would be better off with me.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm24.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The original lifting rings only found on Canadian contract Jeeps and US Marine Corps Jeeps.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both of these Jeeps had been stripped of many parts but there were still lots I could salvage. The frames on both Jeeps were toast. I mean I’ve seen better metal "), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v("sitting on the bottom of the ocean. The bodies were not much better, but the cowls were salvageable and I quickly added them to my parts shed. Here I again ended up with two sets of axles, one Ford and one Willys, a Ford steering box and shaft, and I also managed to get a couple of buckets of F-script bolts and Willys lettered bolts. These bolts alone would end up helping me to fund a good portion of my project down the road. Apparently good original F-script bolts are hard to come by and people are willing to pay for them. There were many other parts as well from both vehicles, but nothing worth special note as they were more common parts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By now I had bought four Jeeps in various states of decay, two CJ2As, a 1944 Ford GP and a 1945 Willys. The second CJ I had purchased from a local museum that had it sitting behind the storage sheds. It had been given to them and they just didn’t need it. So I dragged it home and stripped it down. Not much other than the engine and later T90 style drive train was salvageable, but it all ended up in my shed.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("My Project Jeep")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I now had axles, engines and numerous smaller parts, but as of yet I had only purchased Jeeps with no papers or serial numbers and with few usable body or frame parts for the 1941 to 1945 period. A few months after having moved residences I came across a 1942 Willys Jeep for sale on a buy-and-sell website not too far from where I now lived and that had been posted for several weeks. I thought that it would be sold by the time I had seen the advertisement as I had been busy setting up my new workshop – ummm … I mean house. Amazingly enough, after a short phone call I found that it was still available and, better yet, it had a serial tag. The owner was asking a high price for the Jeep though and I assumed it had turned people off purchasing it without even looking at it. To be honest, just looking at the website photos I could tell it was in rough shape. Nevertheless, I decided to go and have a look. Before I went to see the Jeep though, I looked up the serial number the owner had posted and found it was indeed a 1942 production model. A little further investigation showed me that it was possibly a Canadian Contract 505 Jeep to boot. I was excited to see what it truly looked like first-hand, so off I went.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm25.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Canadian contract not looking so fit in the farmers field.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I first saw the Jeep it was parked in a small field looking quite abused. The owner said it had been driven just that week by his son who had "), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _vm._v("been driving around the bush. The times you will hear that line ‘it ran when parked’ is nauseating. A quick check showed that it did indeed start and move, not well, but it did run. You could probably feel my shock writing that last sentence. I then went over the Jeep looking for tell-tale signs of its origin. I first noticed a single remaining lifting ring on the rear frame and it was definitely an original part. When built, there would have been four of these lifting rings, two fore and two aft, but only on Canadian or US Marine Jeeps.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm26.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Willys and Ford Jeeps on the truck ready to come home.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm27.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The original frame serial tag which has been cleaned and added to the new frame.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm28.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The original Tobe filtrette still under the dash.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm29.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The engine compartment contained many restorable parts that would find their way onto my project.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I then found a mounting unit for the electric windshield wipers on the windshield frame that were fitted to Canadian Jeeps as well as the corresponding hole in the side of the cowl for the wiring harness. Upon further investigation I also found an early Tobe radio suppression filtrette under the cowl, surprisingly still wired in. The best part though, was that the original frame serial tag was where it should be on the front-left inside of the frame, just behind the front bumper. Layers of paint had been scrapped off the tag and I could see some original paint there as well. Unfortunately the data plates that should be located on the glove-box door were missing so I didn’t have the manufacturing date, but at least I knew of its origins. The lifting rings and electric wipers were only used on the Canadian Contract and United States Marine Corps Jeeps so here was more proof. Knowing that the chance of this being a Marine Corps Jeep was slight and I did a quick double-check on the serial number, making sure that this particular Jeep was manufactured in 1942 and that it did indeed fall into the units that were delivered to Canada. Everything checked out. I then went over the Jeep more closely. The large rust holes in the floor pan showed me that the original T-84 transmission case had been replaced with a WOF (Willys of France) T-84. Did that mean this Jeep had been overseas and had had a replacement transmission sometime after 1945? Or was this a transmission purchased and imported into Canada post war. It’s hard to know for sure, but I tend to believe that for some reason this Jeep served overseas and ended up returning to Canada sometime in the 1950s or early 60s. Buying a transmission from Europe in the 50s or 60s would be extremely unlikely and expensive. Also, with so many Jeeps running around North America going so "), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _vm._v("far afield for a part seems unlikely. It did add some mystery to the Jeep, that’s for sure. My first thoughts were: what has this Jeep seen? Did it go into Normandy during the invasion? Whose unit did it belong to? Why was it brought back to Canada? When was it struck off inventory and sold? These questions will probably never be answered, but I do love the mystery these questions provoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later in my Jeep-building journey I was to find out that a friend of mine who owned a Canadian Contract Jeep had a serial number only 363 units away from my Jeep. This means our Jeeps were most likely part of the same shipment, and possibly built on the same day. My Jeep’s new data plates reflect this and personally, I think it’s an awesome coincidence to have two vehicles show up in the same area seventy-six years later owned by two friends.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm30.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("WOF Transmission mounted to the American made DANA SPICER transfer case as found in my Canadian Contract.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went on to find a whole treasure trove of parts that were salvageable. Everything from the axles to transmission and even the single remaining lifting ring was of value. The engine, though, had the tell-tale bulge in the right-side of the water jacket with some kind of putty over it showing that the water had been frozen in it at some point and had cracked the block. Not an insurmountable problem, but an expensive one to get repaired for sure. The engine head, though, was an early one for the Willys MB, so that was good. I began haggling with the owner for a lighter price. He was asking $1800 but after seeing its current condition I offered $800 and a case of beer, his choice of beer. After a minute or two of humming and hawing he relented, we shook hands and I gave him his money with the promise of his beer when I picked up the Jeep the following week. In turn I received a bill of sale and a promise to look for any other parts, including the missing data plates that had either fallen off or had been taken off over the last few years and may be buried in the barn. When I returned the next week no other parts had been found except for one data plate, and this was only the gear selection plate, nothing with pertinent manufacturing details. Damn! The beer was handed over and we rolled the Jeep onto the trailer. It was time to get home and start work. I was as happy as you could imagine the whole drive home.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm31.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm32.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm33.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The 1942 MB at home. While not looking too bad I found many bent, rusted and chopped-up parts.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm34.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm35.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The 1942 Willys opened up and truly examined for parts and posterity. The original Olive Drab can still be seen on the firewall behind the not-so-original air filter. To the right of the air filter and beside the black wrapped wiring is the horn mount. The vibration bracket is hard to find as an original part that hasn’t been destroyed by rust. The bracket is made up of several thin pieces of metal which help reduce the vibration of the horn when used. Also of note is the color of the engine. Upon closer inspection you soon see by way of the casting marks that this is a later CJ2A engine.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm36.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Original horn bracket and vibration mount parts restored. It is missing two metal grommets that were gone when I removed it. These would be replaced with Teflon ones during the restoration process.")])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Canadian Contract Jeeps")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first Jeeps came to Canada in early 1942. These were the first units sold to a foreign entity by the USA. The first 2,000 units were part of the CDLV241/242 Canadian purchasing contract and all had the slat grill, which was a grill made from welded flat steel bar. These grills were used on all production Jeeps up until late March/early April of 1942. At this point the pressed metal grill came into being and is the iconic look still used today. The slat grills were time consuming and labor intensive to produce hence the changeover. After the initial 2000 units had been delivered the contract became CDLV505 and from this point on all Jeeps had the pressed steel grill.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm37.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Here is an early Canadian Contract slat grill. While looking quite simple it was a very time consuming part to manufacturer. The pressed steel grill was quicker to produce and much less expensive. This grill is on a Jeep in the Canadian Forces Museum collection at Camp Borden.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm38.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The standard and most identifiable part of the Jeep is the now iconic stamped steel grill.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Canadian contract Jeeps had some changes not required by the US Army, but as they were the same requirements requested by the US Marine Corps they were delivered as the Canadian establishment requested. It’s highly doubtful that these changes would have been made if the Marine Corps Jeeps had not already had the changes. They were simply not a US contract standard. As mentioned earlier, these Jeeps came with some minor modifications. These changes were the addition of four lifting rings, driver-side electric windshield wiper, defense aid blackout light, headlight guards and right-hand-side tail lights. The addition of the electric windshield wiper meant the windshield cover was slightly modified as well, to accommodate the extra bulge it made.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm39.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Here is an example of a WWII Electric Dyneto wiper motor as found on Canadian Contract and USMC. Jeeps. Note the single pole for the electrical connection. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo courtesy of Olaf Seinen")]), _vm._v(")")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm40.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("My wiper motor, while a Dyneto and of the same era, is slightly different and not the style used by Willys during the war. Instead of one electrical connection mine has two and there is no external condenser.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm41.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An early Slat Grill Canadian 242 Contract Jeep. Probably in England because the bumper has the blackout white edging for nighttime convoy movement. This photo provides a good view of the slat grill, headlight guard and lifting rings. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo courtesy of 8th New Brunswick Hussars Museum")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm42.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another 242 contract Jeep of note is the Mickey Mouse disruptive pattern camouflage on this early Canadian Jeep. Not very common on Canadian vehicles, much less a Jeep. You can see the Dyneto Electric Wiper mounted on the driver-side windscreen as well as its electrical line tracing down the side of the windshield to enter the cowling just above the windshields pivot point. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo courtesy of 8th New Brunswick Hussars Museum")]), _vm._v(")")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the war progressed and the Canadian 505 contract needed filling the Jeeps delivered to Canada were essentially off-the-line vehicles. These Jeeps showed up with no contract specific modifications and entered service as such.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm43.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Somewhere in Italy a late Canadian 505 Contract Jeep. The fender-mounted blackout light shows it is a late delivery as these did not show up on Canadian Jeeps until late July or early August of 1942. You can also see the driver-side windshield wiper is in the off position when compared to the passenger’s hand wiper which is just hanging down on the glass. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo courtesy of 8th New Brunswick Hussars Museum")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm44.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another group of 8th Hussar soldiers posing with a couple of their Jeeps. Notice the dust buildup on the vehicles, changing their color and helping them blend in to the countryside. Again you can see the passenger’s side wiper simply hanging down the windshield. Obviously the wipers tended to loosen and droop after a certain amount of time. This would have been very annoying for a driver if he did not have the electric Dyneto wiper. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo courtesy of 8th New Brunswick Hussars Museum")]), _vm._v(")")])]), _c('div', {
    staticClass: "img_containera"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fm45.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another 505 contract Jeep in the Italian Campaign. Note that this Jeep has been delivered with the fuel-can carrier, rifle rack on the windshield and the fender blackout light. Also of note is the crew addition of a wire cutter mounted on the front bumper. The rifle rack is an uncommon sight on Canadian Jeeps and that his vehicle was pulled from US stocks to fulfill the 505 contract obligation. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo courtesy of 8th New Brunswick Hussars Museum")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000b3fcd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Why.vue
// module id = 75
// module chunks = 0